module.exports = __webpack_public_path__ + "static/thaw-features-bg-b305f547aaf30fee2f7329589672ffb4.png";